import React from "react";
import Header from "../component/sharedComponents/header";
import FooterUser from "../component/sharedComponents/footer";
import CustomIntroSection from "../component/explainBuyPage/customIntroSection";
import { useTranslation } from "react-i18next";
import { SectionLearning } from "../component/dashboardLearning/SectionLearning";
import VideoFeedback from "../assets/Video/Feedback.mp4";
import VideoBrandSlider from "../assets/Video/Brand Slider.mp4";
import VideoSortBrand from "../assets/Video/Sort Brand.mp4";
import VideoCat_Subcat_Brand from "../assets/Video/Cat & Subcat & Brand.mp4";
import VideoCart_1 from "../assets/Video/Cart 1.mp4";
import VideoCart_2 from "../assets/Video/Cart 2.mp4";

const DashboardLearning = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="mt-[55px] md:mt-[54px] lg:mt-[75px] mb-12">
        <CustomIntroSection title={t("dashboardLearning.title")} />
        <SectionLearning
          title={t("dashboardLearning.Cat_subCat_BrandEdit")}
          video={VideoCat_Subcat_Brand}
        />
        <SectionLearning
          title={t("dashboardLearning.feedBackEdit")}
          video={VideoFeedback}
        />
        <SectionLearning
          title={t("dashboardLearning.sortBrandEdit")}
          video={VideoSortBrand}
        />
        <SectionLearning
          title={t("dashboardLearning.brandSliderEdit")}
          video={VideoBrandSlider}
        />

        <SectionLearning
          title={t("dashboardLearning.cartPartOneEdit")}
          video={VideoCart_1}
        />
        <SectionLearning
          title={t("dashboardLearning.cartPartTwoEdit")}
          video={VideoCart_2}
        />
      </div>
      <FooterUser />
    </>
  );
};

export default DashboardLearning;
